/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionInvoice
 */
export interface SubscriptionInvoice {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionInvoice
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInvoice
     */
    amountDue: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInvoice
     */
    amountPaid: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionInvoice
     */
    creditsUsed: number;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionInvoice
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionInvoice
     */
    dueDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionInvoice
     */
    paidAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionInvoice
     */
    refunded: boolean;
}

/**
 * Check if a given object implements the SubscriptionInvoice interface.
 */
export function instanceOfSubscriptionInvoice(value: object): value is SubscriptionInvoice {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('amountDue' in value) || value['amountDue'] === undefined) return false;
    if (!('amountPaid' in value) || value['amountPaid'] === undefined) return false;
    if (!('creditsUsed' in value) || value['creditsUsed'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('refunded' in value) || value['refunded'] === undefined) return false;
    return true;
}

export function SubscriptionInvoiceFromJSON(json: any): SubscriptionInvoice {
    return SubscriptionInvoiceFromJSONTyped(json, false);
}

export function SubscriptionInvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionInvoice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'amountDue': json['amountDue'],
        'amountPaid': json['amountPaid'],
        'creditsUsed': json['creditsUsed'],
        'createdAt': (new Date(json['createdAt'])),
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'paidAt': json['paidAt'] == null ? undefined : (new Date(json['paidAt'])),
        'refunded': json['refunded'],
    };
}

export function SubscriptionInvoiceToJSON(json: any): SubscriptionInvoice {
    return SubscriptionInvoiceToJSONTyped(json, false);
}

export function SubscriptionInvoiceToJSONTyped(value?: SubscriptionInvoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'amountDue': value['amountDue'],
        'amountPaid': value['amountPaid'],
        'creditsUsed': value['creditsUsed'],
        'createdAt': ((value['createdAt']).toISOString()),
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'paidAt': value['paidAt'] == null ? undefined : ((value['paidAt']).toISOString()),
        'refunded': value['refunded'],
    };
}

